import React, { useState } from "react";
import experienceData from "../data/experience.json";
import "../styles/experience.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faExternalLinkAlt,
  faChevronDown,
  faChevronUp,
  faMapMarkerAlt,
  faBriefcase,
  faCalendarAlt,
  faUserTie
} from '@fortawesome/free-solid-svg-icons';

const Experience = () => {
  const [expanded, setExpanded] = useState(null);

  const toggleDetails = (id) => {
    setExpanded(expanded === id ? null : id);
  };

  return (
    <div className="experience-container">
      {/* Header - Matches Projects Exactly */}
      <div className="experience-header">
        <FontAwesomeIcon icon={faUserTie} className="heading-icon" />
        <h1>Professional Experience</h1>
        <p>My career journey and the companies I've contributed to</p>
      </div>

      <div className="experience-timeline">
        {experienceData.map((exp) => (
          <div key={exp.id} className={`experience-card ${expanded === exp.id ? 'expanded' : ''}`}>
            <div className="experience-summary" onClick={() => toggleDetails(exp.id)}>
              <div className="company-logo-container">
                <img 
                  src={exp.companyLogo} 
                  alt={`${exp.companyName} logo`} 
                  className="company-logo" 
                  onError={(e) => {
                    e.target.onerror = null; 
                    e.target.src = 'https://via.placeholder.com/80/3a0ca3/ffffff?text=' + exp.companyName.charAt(0);
                  }}
                />
              </div>
              
              <div className="experience-info">
                <h3>{exp.role}</h3>
                <h4>{exp.companyName}</h4>
                
                <div className="experience-meta">
                  <span>
                    <FontAwesomeIcon icon={faCalendarAlt} />
                    {exp.duration}
                  </span>
                  <span>
                    <FontAwesomeIcon icon={faMapMarkerAlt} />
                    {exp.workLocation}
                  </span>
                  <span>
                    <FontAwesomeIcon icon={faBriefcase} />
                    {exp.jobType}
                  </span>
                </div>
              </div>
              
              <div className="expand-icon">
                <FontAwesomeIcon icon={expanded === exp.id ? faChevronUp : faChevronDown} />
              </div>
            </div>

            {expanded === exp.id && (
              <div className="experience-details">
                <div className="responsibilities">
                  <h5>Key Responsibilities:</h5>
                  <ul>
                    {exp.responsibility.map((item, index) => (
                      <li key={index}>{item}</li>
                    ))}
                  </ul>
                </div>
                
                <div className="skills-gained">
                  <h5>Skills Gained:</h5>
                  <div className="skill-tags">
                    {exp.skillsGained.map((skill, index) => (
                      <span key={index} className="skill-tag">{skill}</span>
                    ))}
                  </div>
                </div>
                
                <a 
                  href={exp.companyWebsite} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="company-website"
                >
                  <FontAwesomeIcon icon={faExternalLinkAlt} />
                  Visit Company Website
                </a>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Experience;